'use client';

import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

// 1. Definimos la forma del Contexto
interface SidebarContextType {
    isOpen: boolean;
    toggleSidebar: () => void;
    setIsOpen: (isOpen: boolean) => void;
}

// 2. Creamos el Contexto
const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

// 3. Creamos el Proveedor del Contexto
interface SidebarProviderProps {
    children: ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(() => {
        // Inicializamos el estado leyendo de localStorage, o por defecto 'true'
        const storedState = localStorage.getItem('sidebarOpen');
        return storedState ? JSON.parse(storedState) : true;
    });

    // Efecto para guardar el estado en localStorage cada vez que cambia
    useEffect(() => {
        localStorage.setItem('sidebarOpen', JSON.stringify(isOpen));
    }, [isOpen]);

    // Función para cambiar el estado
    const toggleSidebar = () => {
        setIsOpen(prev => !prev);
    };

    const value = {
        isOpen,
        toggleSidebar,
        setIsOpen,
    };

    return (
        <SidebarContext.Provider value={value}>
            {children}
        </SidebarContext.Provider>
    );
};

// 4. Creamos un Hook personalizado
export const useSidebar = (): SidebarContextType => {
    const context = useContext(SidebarContext);
    if (context === undefined) {
        throw new Error('useSidebar debe ser usado dentro de un SidebarProvider');
    }
    return context;
};